module.exports = __webpack_public_path__ + "static/img/4.21dd394.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news14/4.png
// module id = jZhp
// module chunks = 1